import React, { Component } from 'react';
import __ from 'lodash';
import { CONFIG,URL_AKM } from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';
import akmApi from '../../../../../apis/akmApi';
import Loader from '../../../../Loader';
import { Form,Row, Col, Card} from 'react-bootstrap';
import {List,ListItem,ListItemText,Collapse, Switch} from '@material-ui/core';
import { MuiPickersUtilsProvider,KeyboardDateTimePicker } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import moment from 'moment';
import { scheduleError } from './scheduleFeedback';

const wibFormatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Asia/Jakarta', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
});

class JadwalMapelForm extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isLoading: false,
            jadwal: {},
            profil: {},
            jadwalSubProfil: [],
            formError: ''
        }
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() { 
        if(!__.isEmpty(this.props.jadwal)) {
            this.setState({
                jadwal: this.props.jadwal,
                profil: this.props.profil
            })
            this.getJadwalSubProfil();    
        }  
        //this.getJadwalById();
            
    }

    getJadwalById = async() => {
        this.setState({ isLoading: true})
        const response = await akmApi.get(CONFIG.EXAM_GET_JADWAL_BY_ID + this.props.jadwal.idJadwal)
        .catch (function(error){ alert(error) })

        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    jadwal: response.data.data
                }) 
            }   
            this.setState({isLoading: false});            
        }        
    }

    getJadwalSubProfil = async() => {
        this.setState({ isLoading: true, formError: '' });
        try {
            const response = await akmApi.get(URL_AKM.GET_JADWAL_MAPEL + this.props.jadwal.idJadwalProfilCbt +'/'+ this.props.profil.idProfilCbt);
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({ jadwalSubProfil: response.data.data });
            } else {
                this.setState({ formError: response.data.errorSchema.errorMessage });
            }
        } catch (error) {
            this.setState({ formError: scheduleError(error) });
        } finally {
            this.setState({ isLoading: false });
        }
    }

    changeJadwalMulai = (value,id) => {   
        this.setState(prev => ({
            jadwalSubProfil: prev.jadwalSubProfil.map(item => item.idSubProfil === id ? { ...item, jadwalMulai: value } : item)
        }))
    }
    changeJadwalSelesai = (value,id) => {        
        this.setState(prev => ({
            jadwalSubProfil: prev.jadwalSubProfil.map(item => item.idSubProfil === id ? { ...item, jadwalSelesai: value } : item)
        }))
    }

    dateFormater(value) {        
        if (!(value instanceof Date) && typeof value !== 'string') return null;
        const text = typeof value === 'string' ? value.trim() : value;
        const date = moment.utc(text, [moment.ISO_8601, 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm'], true);
        if (!date.isValid()) return null;
        // Server menyimpan jam WIB tanpa zona. Isian naif sudah berarti WIB;
        // hanya Date/ISO ber-offset yang merupakan instant untuk dikonversi.
        const isInstant = value instanceof Date || (/[T ]\d{2}:\d{2}/.test(text) && /(?:Z|[+-]\d{2}(?::?\d{2})?)$/i.test(text));
        if (!isInstant) return date.format('YYYY-MM-DD HH:mm:ss');
        const parts = {};
        wibFormatter.formatToParts(date.toDate()).forEach(part => { parts[part.type] = part.value; });
        return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}:${parts.second}`;
    }


    handleSubmit = (e) => {
        e.preventDefault();
        const {jadwal,jadwalSubProfil} = this.state;         

        const rows = jadwalSubProfil.map(item => ({
            ...item,
            idJadwal: jadwal.idJadwalProfilCbt,
            jadwalMulai: this.dateFormater(item.jadwalMulai == null ? jadwal.jadwalMulai : item.jadwalMulai),
            jadwalSelesai: this.dateFormater(item.jadwalSelesai == null ? jadwal.jadwalSelesai : item.jadwalSelesai)
        }));
        if (rows.length === 0 || rows.some(item => !item.jadwalMulai || !item.jadwalSelesai)) {
            this.setState({ formError: 'Lengkapi tanggal mulai dan selesai setiap mapel dengan tanggal yang sah.' });
            return;
        }
        this.setState({ formError: '' });
        this.props.submitJadwalSub(rows, jadwal.idProfilCbt)
        
    }

    render() { 
        const {jadwal,jadwalSubProfil} = this.state;        
        let pageTitle;        
        if(jadwalSubProfil.length !== 0) {
            pageTitle = 'Edit Jadwal Mapel'
        } else {
            pageTitle = 'Add Jadwal Mapel'
        }
        return ( 
            <>            
            <h4>{pageTitle} - {jadwal.namaJadwalCbt}</h4>
            <br />
            {this.state.formError && <div role="alert" className="alert alert-warning">{this.state.formError}</div>}
            {this.state.isLoading ? <Loader /> : 
            <Form onSubmit={this.handleSubmit}>
                {jadwalSubProfil.map((sub,i) =>    
                <Card style={{marginBottom:'5px'}} key={sub.idSubProfil}>
                    <Row>
                        <Col>
                            <ListItem>       
                                <span>{i+1}</span>                             
                                <ListItemText inset primary={sub.namaMapel == null ? sub.namaKategoriSubProfil : sub.namaMapel + '(' + sub.namaKategoriSubProfil + ')'} />    
                            </ListItem>
                        </Col>
                        <Col>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDateTimePicker 
                                value={sub.jadwalMulai === null ? jadwal.jadwalMulai : sub.jadwalMulai} 
                                onChange={(value, id) => this.changeJadwalMulai(value, sub.idSubProfil)}
                                name="jadwalMulai"
                                label="Jadwal Mulai"
                                onError={console.log}
                                ampm={false}
                                format="dd-MM-yyyy HH:mm"
                                minDate={jadwal.jadwalMulai}
                                maxDate={jadwal.jadwalSelesai} 
                            />
                            </MuiPickersUtilsProvider>                        
                        </Col>
                        <Col>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDateTimePicker                            
                                value={sub.jadwalSelesai === null ? jadwal.jadwalSelesai : sub.jadwalSelesai} 
                                onChange={(value, id) => this.changeJadwalSelesai(value, sub.idSubProfil)}
                                name="jadwalSelesai"                 
                                label="Jadwal Selesai"
                                onError={console.log}
                                ampm={false}
                                format="dd-MM-yyyy HH:mm"
                                minDate={jadwal.jadwalMulai} 
                                maxDate={jadwal.jadwalSelesai} 
                            />
                            </MuiPickersUtilsProvider>                        
                        </Col>
                    </Row>
                    <input type="hidden" name="idJadwal" value={jadwal.idJadwalProfilCbt} />
                    <input type="hidden" name="idSubProfil" value={sub.idSubProfil} />
                </Card>                
                )}

                <br />
                <button type="button" className="btn btn-danger" onClick={() => this.handleBack()}><ArrowBackIosIcon fontSize="small"/>Batal</button>
                <button type="submit" className="btn btn-primary pull-right">Simpan</button>
                
            </Form>
            }
            </>    
        );
    }

    handleBack() {
        this.props.handleBack(this.props.idProfil);
    }
}
 
export default JadwalMapelForm;
